
import { DomainSecurityLevel } from '@/types/Catalogs'
import { RecoveryPasswordDetails } from '@/types/RecoveryPassword'
import Vue from 'vue'

export default Vue.component('password-details', {
  props: {
    description: String,
    domainSecurityLevel: {
      type: Number,
      default: DomainSecurityLevel.HIGH
    }
  },
  data () {
    return {}
  },
  computed: {
    recoveryPasswordDetails (): string[] {
      return this.getRecoveryPasswordDetails(this.domainSecurityLevel)
    }
  },
  methods: {
    getRecoveryPasswordDetails (securityLevel: number): string[] {
      return RecoveryPasswordDetails[securityLevel]
    }
  }
})
